module.exports = __webpack_public_path__ + "static/img/stayInControlCard.5274dfba.png";